import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { ShellFrame } from "./ShellFrame";
import { Outlet, useNavigate } from "react-router-dom";
import { HotelContextProvider } from "@/contexts/HotelContext";

export default function AppShell() {
  const nav = useNavigate();
  return (
    <HotelContextProvider>
      <ShellFrame
        renderSidebar={(p) => <Sidebar {...p} onToggle={p.toggle} onClose={p.close} />}
        topbar={<Topbar />}
        mobileActions={<Topbar.MobileSearch />}
        onBell={() => nav("/notifications")}
        onUser={() => nav("/profile")}>
        <Outlet />
      </ShellFrame>
    </HotelContextProvider>
  );
}
